import styled from 'styled-components';

import { useTranslation } from '@hooks';
import { Caption, Caption2 } from '@components/styles/Typography';

const SummaryFeature = ({ color, discount, feature, title }) => {
    const { useCurrency } = useTranslation();
    return (
        <SummaryFeatureWrapper>
            <Caption2 color={color}>{title}</Caption2>
            <Caption>
                {discount && '-'}
                {useCurrency(feature)}
            </Caption>
            {title === 'Cargo' && !feature && (
                <Caption>Not calculated yet</Caption>
            )}
        </SummaryFeatureWrapper>
    );
};

const SummaryFeatureWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
    width: 100%;
`;

export default SummaryFeature;
